import React, { useState } from 'react';
import { includes, equals, head, propEq, find } from 'ramda';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, Button } from '@material-ui/core';
import Radio from 'sharedComponents/Radio';

import SubscriptionInfoPresenter from 'presenters/SubscriptionInfoPresenter';
import SubscriptionPresenter from 'presenters/SubscriptionPresenter';

import useStyles from './useStyles';

const SubscriptionInfo = props => {
  const { t } = useTranslation();
  const { subscriptionInfo, onFinish, isLoading } = props;
  const classes = useStyles();

  const subscriptions = SubscriptionInfoPresenter.subscriptions(subscriptionInfo);
  const currentProductsSubscriptionsIds = SubscriptionInfoPresenter.productsSubscriptionsIds(subscriptionInfo);
  const [selectedSubscriptionIds, setSelectedSubscriptionIds] = useState(currentProductsSubscriptionsIds);

  const handleChangeSubscription = ({ target: { value } }) => {
    setSelectedSubscriptionIds([Number(value)]);
  };

  const isDisabled = equals(currentProductsSubscriptionsIds, selectedSubscriptionIds);

  const handleSave = () => {
    const currentSelectedId = head(selectedSubscriptionIds);
    const subscription = find(propEq('id', currentSelectedId))(subscriptions);
    const products = head(SubscriptionInfoPresenter.products(subscriptionInfo));
    const params = {
      products: [
        {
          ...products,
          subscriptionInfo: { subscriptionId: currentSelectedId, name: SubscriptionPresenter.name(subscription) },
        },
      ],
    };
    onFinish(params);
  };

  return (
    <div>
      <Typography variant="h2" className={classes.header}>
        {t('components.SubscriptionPage.SubscriptionInfo.header')}
      </Typography>
      <div className={classes.container}>
        <div className={classes.subscriptions}>
          <div className={classes.plans}>
            {subscriptions.map(subscription => {
              const planLabel = SubscriptionPresenter.subscriptionAmountLabel(subscription);
              const checked = includes(subscription.id, selectedSubscriptionIds);
              return (
                <div className={classes.planItem} key={subscription.id}>
                  <Typography variant="subtitle1" color="secondary">
                    {SubscriptionPresenter.name(subscription)}
                  </Typography>
                  <div className={classes.planControlBar}>
                    <Radio
                      className={classes.radioButton}
                      checked={checked}
                      onChange={handleChangeSubscription}
                      value={subscription.id}
                    />
                    <Typography variant="body1" color="inherit">
                      {planLabel}
                    </Typography>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <Button onClick={handleSave} disabled={isDisabled || isLoading} className={classes.saveButton}>
          {t('components.SubscriptionPage.SubscriptionInfo.saveButton')}
        </Button>
      </div>
    </div>
  );
};

SubscriptionInfo.propTypes = {
  subscriptionInfo: SubscriptionInfoPresenter.shape(),
  isLoading: PropTypes.bool.isRequired,
  onFinish: PropTypes.func.isRequired,
};

SubscriptionInfo.defaultProps = {
  subscriptionInfo: {},
};

export default SubscriptionInfo;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/SubscriptionInfo/SubscriptionInfo.js